// A210C 上行口设备列表：与 HTML UFP_VENDOR_NAMES / UFP_PRODUCT_NAMES 保持一致。
const DeviceModelMap: Record<number, Record<number, string>> = {
  0x0001: {
    0x0001: 'iPhone 12系列',
    0x0005: 'iPhone 12 Pro Max',
    0x0006: 'iPhone SE 3',
    0x0007: 'iPhone 13系列',
    0x0008: 'iPhone 13 mini',
    0x000b: 'iPhone 13 Pro Max',
    0x000c: 'iPhone 14系列',
    0x000f: 'iPhone 14 Plus',
    0x0010: 'iPhone 14 Pro Max',
    0x0011: 'iPhone 15',
    0x0012: 'iPhone 15 Plus',
    0x0013: 'iPhone 15 Pro',
    0x0014: 'iPhone 15 Pro Max',
    0x0015: 'iPhone 16系列',
    0x0016: 'iPhone 16',
    0x0017: 'iPhone 16 Plus',
    0x0018: 'iPhone 16E',
    0x0019: 'iPhone 16 Pro系列',
    0x001a: 'iPhone 16 Pro',
    0x001b: 'iPhone 16 Pro Max',
    0x001c: 'iPhone 17系列',
    0x001d: 'iPhone 17',
    0x001e: 'iPhone 17 Air',
    0x001f: 'iPhone 17 Pro系列',
    0x0020: 'iPhone 17 Pro',
    0x0021: 'iPhone 17 Pro Max',
    0x0022: 'iPad 9',
    0x0023: 'iPad 10',
    0x0024: 'iPad 11',
    0x0025: 'iPad Air 4',
    0x0026: 'iPad Air 5',
    0x0027: 'iPad Air 11" (2024)',
    0x0028: 'iPad Air 13" (2024)',
    0x0029: 'iPad Air 11" (2025)',
    0x002a: 'iPad Air 13" (2025)',
    0x002b: 'iPad mini 6',
    0x002c: 'iPad mini 7',
    0x002d: 'iPad Pro 2020系列',
    0x002e: 'iPad Pro 11" (2020)',
    0x002f: 'iPad Pro 12.9" (2020)',
    0x0030: 'iPad Pro M1系列',
    0x0031: 'iPad Pro 11" M1',
    0x0032: 'iPad Pro 12.9" M1',
    0x0033: 'iPad Pro M2系列',
    0x0034: 'iPad Pro 11" M2',
    0x0035: 'iPad Pro 12.9" M2',
    0x0036: 'iPad Pro M4系列',
    0x0037: 'iPad Pro 11" M4',
    0x0038: 'iPad Pro 13" M4',
    0x0039: 'iPad Pro M5系列',
    0x003a: 'iPad Pro 11" M5',
    0x003b: 'iPad Pro 13" M5',
    0x003c: 'MacBook Air 2020',
    0x003d: 'MacBook Air M1',
    0x0040: 'MacBook Air M2',
    0x0041: 'MacBook Air 13" M3',
    0x0042: 'MacBook Air 13" M4',
    0x0043: 'MacBook Air 15" (2023)',
    0x0044: 'MacBook Air 15" M3',
    0x0045: 'MacBook Air 15" M4',
    0x0046: 'MacBook Pro 13" M2',
    0x0047: 'MacBook Pro 14" M1 系列',
    0x0048: 'MacBook Pro 14" M2 系列',
    0x0049: 'MacBook Pro 14" M3',
    0x004a: 'MacBook Pro 14" M4 系列',
    0x004b: 'MacBook Pro 14" M4 系列',
    0x004c: 'MacBook Pro 14" M4 系列',
    0x004d: 'MacBook Pro 14" M5',
    0x004e: 'MacBook Pro 16" M1 系列',
    0x004f: 'MacBook Pro 16" M2 系列',
    0x0050: 'MacBook Pro 16" M3 系列',
    0x0051: 'MacBook Pro 16" M4 系列',
    0x0052: 'MacBook Pro 16" M4 系列',
    0x0053: 'MacBook Pro 16" M4 系列',
    0x0054: 'HomePod Mini',
    0x0055: 'iPhone 17e',
    0x0056: 'iPad Air 11" (2026)',
    0x0057: 'iPad Air 13" (2026)',
    0x0058: 'MacBook Air 13" (2026)',
    0x0059: 'MacBook Air 15" (2026)',
    0x005a: 'MacBook Pro 16" M5 系列',
    0x005b: 'MacBook Neo',
    0x005c: 'MacBook Pro 14" M5 系列',
    0x005d: 'MacBook Pro 14" M3 系列',
  },
  0x000e: {
    0x0001: 'ThinkBook 16 2025',
    0x0002: 'ThinkPad X1 Carbon 2025',
    0x0003: 'YOGA 7 (Air 14c)',
    0x0004: 'YOGA Pro 14s',
    0x0005: 'YOGA Air 15s 2025',
  },
}

/**
 * 根据嵌入式上报的 vendorIndex 和 productIndex 解析设备显示名称。
 * 与设备端口径一致：
 *  - 已收录机型 → 产品名（如 MacBook Pro 14" M4 系列）
 *  - 识别不到的机型 → 统一显示 'device'（设备端对所有未识别机型即如此显示，
 *    含厂商未知、productIndex 未收录、0xFFFF 等一切情况）
 */
export function resolveDeviceName(
  vendorIndex: number,
  productIndex: number
): string {
  return DeviceModelMap[vendorIndex]?.[productIndex] ?? 'device'
}

export default DeviceModelMap
